import {
  UPSERT_PAYMENT_SUCCESS,
  UPSERT_PAYMENT_FAILED,
  PROCEED_PAYMENT_SUCCESS,
  PROCEED_PAYMENT_FAILED,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPSERT_PAYMENT_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        data: action.data,
      };
    case UPSERT_PAYMENT_FAILED:
      return { ...state, status: 'error', error: action.error };
    case PROCEED_PAYMENT_SUCCESS:
      return {
        ...state,
        status: 'proceed_success',
        message: action.message,
        data: action.data,
      };
    case PROCEED_PAYMENT_FAILED:
      return { ...state, status: 'proceed_error', error: action.error };
    default:
      return state;
  }
};
